import getUrlParam from './getUrlParam';

const userAgent = navigator.userAgent || navigator.vendor || window.opera;

function getMobileOS() {
  if (/windows phone/i.test(userAgent)) {
    return 'Windows Phone';
  }

  if (/android/i.test(userAgent)) {
    return 'Android';
  }

  if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
    return 'iOS';
  }

  return 'unknown';
}

function getContainer() {
  if (typeof callNative === 'function') {
    return 'app';
  }

  const wvVersion = userAgent.match(/WindVane[/\s](\d+[._]\d+[._]\d+)/);
  if (wvVersion && wvVersion.length) {
    return 'webview';
  }

  return 'browser';
}

function getEnv() {
  const debugEnv = getUrlParam('cscEnv');
  if (debugEnv) {
    return debugEnv;
  }

  if (process.env.NODE_ENV === 'development') {
    return 'dev';
  } else if (document.location.host.includes('pre')) {
    return 'pre';
  }
  return 'live';
}

function getVenture() {
  if (window.g_config && window.g_config.regionID) {
    return window.g_config.regionID;
  }
  return window.location.hostname
    .split('.')
    .pop()
    .toUpperCase();
}

const Env = {
  container: getContainer(),
  platform: getMobileOS(),
  env: getEnv(),
  venture: getVenture(),
};
Env.isWebview = Env.container === 'webview';

export default Env;



// WEBPACK FOOTER //
// ./src/utils/env.js